// src/components/FloatingButtons/FloatingButtons.js
import React, { useState, useEffect } from 'react';
import styles from './FloatingButtons.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faArrowUp } from '@fortawesome/free-solid-svg-icons'; // faPhoneAlt est bien solide

const FloatingButtons = () => {
  const phoneNumber = "06 98 01 25 29";

  // État pour contrôler la visibilité du bouton "retour en haut"
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  // Gérer la visibilité du bouton de retour en haut en fonction du défilement
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) { // Affiche le bouton après 300px de défilement
        setShowScrollTopButton(true);
      } else {
        setShowScrollTopButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {/* Bouton Téléphone */}
      <a href={`tel:${phoneNumber}`} className={styles.phoneButton} aria-label="Appeler le restaurant">
        <FontAwesomeIcon icon={faPhoneAlt} className={styles.phoneIcon} />
        {/* Le texte n'est visible que sur desktop grâce au CSS */}
        <span className={styles.phoneNumberText}>{phoneNumber}</span>
      </a>

      {/* Bouton Retour en haut */}
      {showScrollTopButton && (
        <button onClick={scrollToTop} className={styles.scrollTopButton} aria-label="Retourner en haut de la page">
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      )}
    </>
  );
};

export default FloatingButtons;